<script setup lang="ts">
import { computed } from "vue";
import type { Field } from "@yawhub/core";
type Window = {
  fieldId: string;
  unit: "day" | "week" | "month";
  count: number;
  timezone: string;
};
const props = defineProps<{ fields: Field[]; disabled?: boolean }>();
const window = defineModel<Window | undefined>();
const dates = computed(() =>
  props.fields.filter(
    (f) => f.active && f.queryable && ["date", "datetime"].includes(f.type),
  ),
);
const selection = computed(() =>
  !window.value ? "all" : window.value.unit + ":" + window.value.count,
);
function select(value: string) {
  if (value === "all") {
    window.value = undefined;
    return;
  }
  const [unit, count] = value.split(":");
  window.value = {
    fieldId: window.value?.fieldId || dates.value[0]?.id || "",
    unit: unit as Window["unit"],
    count: Number(count),
    timezone: window.value?.timezone || "Europe/Copenhagen",
  };
}
</script>
<template>
  <div class="form-grid period-fields">
    <label
      >Periode<select
        :value="selection"
        :disabled="disabled"
        @change="select(($event.target as HTMLSelectElement).value)"
      >
        <option value="all">Alle data</option>
        <option value="day:7" :disabled="!dates.length">
          Seneste 7 hele dage
        </option>
        <option value="day:30" :disabled="!dates.length">
          Seneste 30 hele dage
        </option>
        <option value="week:1" :disabled="!dates.length">Sidste uge</option>
        <option value="month:1" :disabled="!dates.length">Sidste måned</option>
        <option value="month:12" :disabled="!dates.length">
          Seneste 12 hele måneder
        </option>
        <option
          v-if="
            window &&
            !['day:7', 'day:30', 'week:1', 'month:1', 'month:12'].includes(
              selection,
            )
          "
          :value="selection"
        >
          Gemt periode
        </option>
      </select></label
    >
    <label v-if="window"
      >Brug datoen fra<select
        v-model="window.fieldId"
        :disabled="disabled"
        required
      >
        <option v-for="f in dates" :key="f.id" :value="f.id">
          {{ f.label }}
        </option>
      </select></label
    >
  </div>
  <p v-if="window" class="muted small">
    Perioden flytter sig automatisk og følger kalenderen i
    {{ window.timezone === "Europe/Copenhagen" ? "Danmark" : window.timezone }}.
    Den igangværende dag, uge eller måned tælles ikke med.
  </p>
</template>
